import { Injectable, Injector, inject } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';

import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, last } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { DatabaseService } from './database/database.service';
import { FsessionService } from './session/fsession.service';
import { configuracion } from 'src/configuracion';
import { SeguimientoService } from './seguimiento/seguimiento.service';
import { environment } from 'src/environments/environment';
import { MessageService } from './message/message.service';
export interface Credendial {
  accessToken: string;
  refreshToken: string;
  expiration: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private ds = inject(DatabaseService);
  private fse = inject(FsessionService);
  private seguimiento = inject(SeguimientoService);
  private router = inject(Router);
  private msalService = inject(MsalService);
  private messageService = inject(MessageService);
  private readonly injector = inject(Injector);

  private translations = {
    Tiempo_Agotado: null,
    suusuarionoestaautorizado: null,
  };
  private translateService: TranslateService;

  activarReportes: boolean = false;
  vS = configuracion.servidor_Stream;
  isRefreshingToken: boolean = false;
  tokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  whitelistedDomains: string[] = environment.whitelistedDomains;
  redirectInProgress: boolean = false;

  constructor() {
    setTimeout(async () => {
      this.translateService = this.injector.get(TranslateService);
      await this.getTranslations();
      this.fse.getSubscribeLang().subscribe(async () => await this.getTranslations());
    }, 0);
  }
  /**
   * Funcion para interceptar todas las peticiones
   * @param request solicitud
   * @param next Envio
   * @returns
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Verificar si la solicitud proviene de un dominio permitido
    const isAssetsRequest = request.url.startsWith('/assets/') || request.url.startsWith('./assets/');

    // Verifica si la solicitud es de archivos de traducción
    const isTranslationsFiles = request.url.includes(configuracion.translations_URL);

    // Streaming no debe llevar Municipality-Timezone (CORS del gateway de video)
    const isStreamingRequest =
      (!!configuracion.ws_Stream_new && request.url.includes(configuracion.ws_Stream_new)) ||
      (!!configuracion.servidor_Stream && request.url.includes(configuracion.servidor_Stream));

    if (this.isWhitelistedDomain(request.url) || this.isWhitelistedDomain(configuracion.apiIpPublica) || isAssetsRequest) {
      // omitimos el establecimiento de "headers"
      if (isTranslationsFiles || isStreamingRequest) return next.handle(request);

      return next.handle(this.addHeadersToRequest(request)).pipe(
        catchError((error: HttpErrorResponse) => throwError(this.decryptServerResponse<HttpErrorResponse>(error))),
        last(),
        map((response) => this.decryptServerResponse<HttpEvent<HttpResponse<any>>>(response)),
      );
    } else {
      // Evitar redireccionamiento múltiple
      if (!this.redirectInProgress) {
        this.redirectInProgress = true;

        // Cerrar sesión y redirigir al inicio de sesión
        this.fse.closeSession();
        this.logoutAndRedirect();
      }
      return new Observable();
    }
  }

  /**
   * redirigiar al login b2c
   */
  logoutAndRedirect(): void {
    this.msalService.logoutRedirect().subscribe(() => {
      this.router.navigate(['login-failed']);
    });
  }

  /**
   * Validad dominios en la whitelist
   * @param url dominio
   * @returns true | false
   */
  isWhitelistedDomain(url: string): boolean {
    return this.whitelistedDomains.some((domain) => url.includes(domain));
  }

  /**
   * agregar datos al header en las peticiones
   * @param request solicitud
   * @returns retorna la solicitud
   */
  addHeadersToRequest(request: HttpRequest<any>): HttpRequest<any> {
    const municipalityTimeZone = this.fse.optenerValor('dato41');

    return request.clone({
      setHeaders: {
        ...(typeof municipalityTimeZone === 'string' && municipalityTimeZone.length > 0
          ? { 'Municipality-Timezone': municipalityTimeZone }
          : {}),
      },
    });
  }

  /**
   * Función que permite descifrar la información que llega del servidor
   * @param response HttpEvent<T> | HttpErrorResponse
   * @deprecated Ya no se encripta
   * @returns HttpEvent<T> que representa todos los tipos posibles de respuesta en este caso solo dos (HttpEvent, HttpErrorResponse)
   */
  decryptServerResponse<T>(response: HttpEvent<T> | HttpErrorResponse): HttpEvent<T> {
    return response as HttpEvent<T>;
  }

  /**
   * Realiza las traducciones cada vaz que se invoque
   * @returns {Promise<boolean>}
   */
  getTranslations(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.translateService.get(['Tiempo_Agotado', 'suusuarionoestaautorizado']).subscribe((translations) => {
        this.translations = translations;
        resolve(true);
      });
    });
  }
}

export const AuthinterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthInterceptor,
  multi: true,
};
